<template>
  <div>
    <PartnerHeader :img_header="header_image" header="รายการข่าวสาร" link_back="managepos"/>
    <MenuPartner/>
    <news_information/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/store.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import news_information from "@/components/admin/manage_pos/news_store_setting/News_information";
export default {
  name: "NewsInformation",
  components: {
    PartnerHeader,
    news_information,
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
